import { ArrowUpRight } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import type { Project } from "../domain/schemas";

const maturityLabels: Record<Project["maturity"], string> = {
  production: "Em produção",
  evolving: "Em evolução",
  validation: "Em validação",
  historical: "Histórico",
  documenting: "Case em documentação",
};

export function ProjectVisual({ project, compact = false }: { project: Project; compact?: boolean }) {
  const variants = ["amber", "green", "coral"] as const;
  const variant = project.featured ? "amber" : variants[[...project.slug].reduce((sum, character) => sum + character.charCodeAt(0), 0) % variants.length];
  return <article className={`project-card ${compact ? "compact" : ""}`}>
    <div className="project-cube-wrap" aria-hidden="true"><img src={`/assets/project-cube-${variant}.webp`} alt="" width={600} height={600} decoding="async" /></div>
    <div className="project-card-copy"><div className="project-meta"><span>{project.category}</span><strong>{maturityLabels[project.maturity]}</strong></div><p>{project.period}</p><h3>{project.title}</h3><span>{project.summary}</span><small>{project.role}</small><ul className="tag-list">{project.stack.slice(0, 4).map((item) => <li key={item}>{item}</li>)}</ul><Link to={`/projetos/${project.slug}`}>Abrir estudo de caso <ArrowUpRight /></Link></div>
  </article>;
}
